import { Problem } from '@yandex-int/k-common';
import { EDITOR_TYPES, RobotProblem } from '../../components/robot/robot.types';
import { getEditor } from '../../components/robot/__code-container/utils';
import { useNewMobilePaginatorIsVisible } from './useNewMobilePaginatorIsVisible';

const checkProblemIsRobotProblem = (problem: Problem | RobotProblem): problem is RobotProblem => {
    return problem?.type === 'robot';
};

export const useMobileRobotViewAvailability = (problem?: Problem | RobotProblem | null) => {
    const newMobilePaginatorIsVisible = useNewMobilePaginatorIsVisible();

    if (!problem) {
        return false;
    }

    const problemIsRobotProblem = checkProblemIsRobotProblem(problem);

    if (!problemIsRobotProblem) {
        return false;
    }

    const editor = getEditor(problem.markup);

    const shouldShowMobileRobotView = Boolean(
        [EDITOR_TYPES.BLOCKLY_PYTHON, EDITOR_TYPES.PYTHON].includes(editor.editor) && newMobilePaginatorIsVisible
    );

    return shouldShowMobileRobotView;
};
